import { CHART_FIELD, CHART_GRAPH } from '@/entities/chart/model/constants';
import type { WordCloudBasis } from '@/features/WordCloud/types';

/**
 * CHART_FIELD → WordCloudBasis 변환
 * API 호출 경계에서만 사용할 것
 */
export const fieldToWordCloudBasis = (fieldType?: CHART_FIELD): WordCloudBasis => {
  switch (fieldType) {
    case CHART_FIELD.FEEDBACK_HASHTAG:
      return 'hashtags';
    case CHART_FIELD.FEEDBACK_MENTION:
      return 'mentions';
    default:
      return 'keywords';
  }
};

export const isWordCloudDatasetField = (fieldType?: CHART_FIELD) => {
  return (
    fieldType === CHART_FIELD.FEEDBACK_KEYWORD ||
    fieldType === CHART_FIELD.FEEDBACK_HASHTAG ||
    fieldType === CHART_FIELD.FEEDBACK_MENTION
  );
};

export const isWordCloudGraph = (graph?: CHART_GRAPH) => {
  return graph === CHART_GRAPH.WORD_CLOUD;
};
